import { defineComponent as _defineComponent } from 'vue'
import { Icon } from 'ant-design-vue';
import { useGlobalNotification } from '@/shared/composables/useGlobalNotification';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalBannerNotification',
  setup(__props) {

const { isGlobalNotificationVisible, closeGlobalNotification } = useGlobalNotification();

return { __sfc: true,isGlobalNotificationVisible, closeGlobalNotification, Icon }
}

})